
  import {Component, Vue, Watch} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import AppInputMoney from "@/components/AppInputMoney.vue";
  import {httpResource} from "@/resources/http.resource";
  import moment from 'moment';

  @Component({
    components: {
      AppDialog,
      AppInputMoney,
    },
  })
  export default class BankAccountDocument extends Vue {
    $refs: any;
    currentPopup = { blockName: 'payment', dialogName: 'bankAccountDocument' };
    money = 0;
    payDocument: any = {};

    async pay() {
      let asyncAction = async () => {
        const params: any = {
          tsum: this.money,
          invoiceNumber: this.$refs.appDialog.payloadPopup.invoiceNumber,
        };
        const {data: {result: response }} = await httpResource.httpAction({ action: 'invoice', params });
        this.payDocument = response;
        this.printTable();

        await this.onClose();
      };

      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    printTable() {
      let payload = this.$refs.appDialog.payloadPopup;
      const iframe = document.createElement('iframe');
      iframe.style.position = 'absolute';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = 'none';
      document.body.appendChild(iframe);

      const mywindow = iframe.contentWindow;

      // let mywindow = window.open('', 'PRINT', 'height=400,width=600');
      mywindow.document.write(`<html><head><title>Счет на оплату №${payload.invoiceNumber}</title><style>
          table {
            width: 100%;
          }
          td {
            padding: 3px 10px;
            vertical-align: top;
          }

          table, th, td {
            border: 1px solid black;
            border-collapse: collapse;
          }

          /* Стили для печати - скрываем колонтитулы */
          @page {
            size: auto;
            margin: 10mm;

            /* Скрываем верхний колонтитул (дата, URL) */
            @top-center {
              content: "";
              display: none;
            }

            /* Скрываем нижний колонтитул (нумерация страниц) */
            @bottom-center {
              content: "";
              display: none;
            }

            @bottom-right {
              content: "";
              display: none;
            }

            @bottom-left {
              content: "";
              display: none;
            }

            /* Альтернативный способ для разных браузеров */
            margin-header: 0;
            margin-footer: 0;
          }

          /* Дополнительные стили для браузеров */
          @media print {
            /* Скрываем URL и дату в верхнем колонтитуле */
            #header, .header, header {
              display: none;
            }

            /* Скрываем нумерацию страниц */
            #footer, .footer, footer {
              display: none;
            }

            /* Убираем лишние отступы */
            body {
              margin: 0;
              padding: 0;
            }
          }

          /* Специфичные правила для WebKit браузеров (Chrome, Safari) */
          @page {
            margin: 2cm;

            /* Для Chrome */
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          /* Для Firefox */
          @-moz-document url-prefix() {
            @page {
              margin: 2cm;
            }
          }

          /* Скрываем пустые строки, которые могут появляться */
          body:after {
            display: none;
          }
      </style></head><body >`);

      let text = `
      <table>
          <tr>
            <td rowspan="2" colspan="2" width="50%">
              ${this.payDocument.bankName}
              <br>
              Банк поулчателя
            </td>
            <td width="10%">БИК</td>
            <td width="40%">${this.payDocument.bic}</td>
          </tr>
          <tr>
            <td>Сч. №</td>
            <td>${this.payDocument.accountBank}</td>
          </tr>
          <tr>
            <td width="25%">ИНН &nbsp; ${this.payDocument.inn}</td>
            <td width="25%">КПП</td>
            <td rowspan="2" width="10%" style="vertical-align: top">Сч. №</td>
            <td rowspan="2" style="vertical-align: top">${this.payDocument.account}</td>
          </tr>
          <tr>
            <td colspan="2" width="50%">
              ${this.payDocument.supplayerShort}
              <br>
              Получатель
            </td>
          </tr>
        </table>

        <h2>Счет на оплату №${payload.invoiceNumber} от ${moment(new Date()).format('DD.MM.YYYY')}</h2>
        <hr>
        <table style="border: none">
          <tr>
            <td width="10%" style="border: none">Поставщик<br>(Исполнитель)</td>
            <td width="90%" style="border: none"><b>${this.payDocument.supplayer}</b></td>
          </tr>
          <tr>
            <td width="10%" style="border: none">Покупатель<br>(Заказчик)</td>
            <td width="90%" style="border: none"><b>${this.payDocument.buyer}</b></td>
          </tr>
        </table>

        <br>
        <br>
        <table style="text-align: center; border: none">
          <tr>
            <th>№</th>
            <th>Товары (работы, услуги)</th>
            <th>Кол-во</th>
            <th>Ед.</th>
            <th>Цена</th>
            <th>Сумма</th>
          </tr>
          <tr>
            <td>1</td>
            <td style="text-align: left">${this.payDocument.articulName}</td>
            <td>${this.payDocument.quantity}</td>
            <td>${this.payDocument.unitName}</td>
            <td>${this.payDocument.price}</td>
            <td>${this.$options.filters.currency(this.payDocument.tSum, '')}</td>
          </tr>
          <tr>
            <td colspan="3" style="border: none"></td>
            <td colspan="2" style="text-align: right; border: none"><b>Итого:</b></td>
            <td style="border: none"><b>${this.$options.filters.currency(this.payDocument.tSum, '')}</b></td>
          </tr>
          <tr>
            <td colspan="3" style="border: none"></td>
            <td colspan="2" style="text-align: right; border: none"><b>Без налога (НДС)</b></td>
            <td style="border: none"><b>-</b></td>
          </tr>
          <tr>
            <td colspan="3" style="border: none"></td>
            <td colspan="2" style="text-align: right; border: none"><b>Всего к оплате:</b></td>
            <td style="border: none"><b>${this.$options.filters.currency(this.payDocument.tSum, '')}</b></td>
          </tr>
        </table>
        <p>
          Всего наименований 1, на сумму ${this.$options.filters.currency(this.payDocument.tSum, 'руб.')}
          <br>
          <b>${this.payDocument.tSumRus}</b>
        </p>
        <p>${this.payDocument.datePayTo}</p>`;
      mywindow.document.write(text);

      mywindow.document.write('</body></html>');
      mywindow.document.close();
      mywindow.focus();
      mywindow.print();
      mywindow.close();

      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    }

    async closeAction() {
      // await this.$store.dispatch('dialog/openDialog', { blockName: 'payment', dialogName: 'balancePopup' });
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }
  }
